module.exports = __webpack_public_path__ + "static/media/icon-nedvex.2d093b5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/type-filters/icon-nedvex.svg
// module id = 562
// module chunks = 0